module.exports = __webpack_public_path__ + "assets/img/4_1553_big.2d10ea81.jpg";